import { render, staticRenderFns } from "./CamaraDashboard.vue?vue&type=template&id=5de68be6&scoped=true&"
import script from "./CamaraDashboard.vue?vue&type=script&lang=ts&"
export * from "./CamaraDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CamaraDashboard.vue?vue&type=style&index=0&id=5de68be6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de68be6",
  null
  
)

export default component.exports